
<!-- TODO: Traiter surTitre,titre et sousTitre -->
<div
  :class="jel_getClassObject(content)"
  class="d-flex flex-column imgPleineLargeur text-align-center p-0"
>
  <div class="cursor-pointer pt-2" @click="jel_forcerClickHyperlien(refRedirection)">
    <b-link :ref="refRedirection" v-bind="jel_getLienBinding(content.lien)" class="d-none">
      <!-- conserver pour accessibilité -->
      invisible</b-link
    >
    <!-- TODO: Erreur d'accessibilité. Un inline element ne peut contenir un block element -->
    <b-img-lazy
      :src="jel_getFichierSrc(content.image)"
      :alt="content.altImage"
      class="w-100 imgExplorer px-2"
    />
    <p class="texte titreJeu" v-html="content.titre"></p>
  </div>
</div>
